import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useSpaceTabQuery } from 'queries/project-spaces';
import { spaceTabSuccessSagaAction } from '../actions';
import { selectSpaceTab } from '../selectors';

export const useSpaceTab = (spaceTabId: number) => {
  const dispatch = useDispatch();

  const { data, ...rest } = useSpaceTabQuery(spaceTabId, {
    enabled: !!spaceTabId,
    onSuccess: (response) => {
      dispatch(spaceTabSuccessSagaAction(response));
    },
  });
  const spaceTab = useSelector(selectSpaceTab(spaceTabId), shallowEqual);

  return {
    data: spaceTab,
    ...rest,
  };
};
